(function () {
  function syncPdfNote(dialog) {
    var preview = dialog.querySelector('.uploadcare--tab_name_preview.uploadcare--tab_current');
    var note = dialog.querySelector('.kn-uploadly-pdf-note');
    var hasPdf = preview && !preview.querySelector('.uploadcare-tab-effects--image-container') && (
      preview.querySelector('[data-pdf-parent="true"]') ||
      Array.from(preview.querySelectorAll('.uploadcare--file__name')).some(function (file) {
        return /\.pdf$/i.test((file.getAttribute('title') || file.textContent).trim());
      })
    );
    var labels = document.querySelector('[data-upload-pdf-title]');
    var header = preview?.querySelector('.uploadcare--tab__header');
    if (!hasPdf || !labels || !header) {
      note?.remove();
      return;
    }
    if (!note) {
      note = document.createElement('div');
      note.className = 'kn-uploadly-pdf-note';
      note.setAttribute('role', 'note');
      var title = document.createElement('strong');
      title.textContent = labels.dataset.uploadPdfTitle;
      var body = document.createElement('p');
      body.textContent = labels.dataset.uploadPdfBody;
      note.append(title, body);
      header.insertAdjacentElement('afterend', note);
    }
  }

  function syncDialogLimit(dialog) {
    var button = dialog.querySelector('#uploadcare__add_more_files_btn');
    if (!button) return;
    var field = Array.from(document.querySelectorAll('.kn-uploadly-card [data-ph-fieldname]')).find(function (node) {
      return node.getClientRects().length > 0;
    });
    var name = field?.dataset.phFieldname || window.UPLOADCARE_FIELD || '';
    var configured = window.field_data?.data?.find(function (entry) { return entry.fieldname === name; }) || window.UPLOADCARE_DATA?.[name];
    var maximum = Number(configured?.maximumFiles) || Number(name.match(/^[A-Z]+(\d+)\s+Uploaded Picture/i)?.[1]) || (name.startsWith('ILLUST ') ? 3 : 1);
    var chosen = dialog.querySelectorAll('.uploadcare--preview__content .uploadcare--files__item').length;
    dialog.classList.toggle('kn-uploadly-at-limit', chosen >= maximum);
  }

  var dialogObserver = new MutationObserver(function () {
    document.querySelectorAll('.uploadcare--dialog').forEach(function (dialog) {
      syncDialogLimit(dialog);
      syncPdfNote(dialog);
    });
  });
  dialogObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-pdf-parent'] });

  // Uploadly's add-more handler clicks a hidden action in the preview tab.
  // Open the native file-source panel first, retaining the existing file list.
  document.addEventListener('click', function (event) {
    var button = event.target.closest?.('#uploadcare__add_more_files_btn');
    if (!button) return;
    var dialog = button.closest('.uploadcare--dialog');
    var fileSource = dialog?.querySelector('.uploadcare--menu__item_tab_file');
    if (!fileSource) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    fileSource.click();
  }, true);

  function setupUploadCards() {
    document.querySelectorAll('.kn-uploadly-card:not([data-upload-card-ready])').forEach(function (card) {
      card.dataset.uploadCardReady = 'true';
      var target = card.querySelector('.kn-uploadly-card__target');
      var previewButton = card.querySelector('.kn-uploadly-card__preview-cta');
      var status = card.querySelector('.kn-uploadly-card__status');
      var dragDepth = 0;

      function showStatus(message) {
        status.textContent = message;
        status.hidden = false;
      }

      function hasFiles(event) {
        var transfer = event.dataTransfer;
        return !!transfer && (Array.from(transfer.types || []).indexOf('Files') !== -1 || transfer.files.length > 0);
      }

      function clearDrag() {
        dragDepth = 0;
        card.classList.remove('kn-uploadly-card--dragging');
      }

      function uploaderBusy() {
        return !!card.querySelector('.uploadcare--widget[aria-busy="true"], .uploadcare--widget[data-status="started"]');
      }

      function syncUploader() {
        var uploadButtons = card.querySelectorAll('.uploadcare--widget__button_type_open');
        uploadButtons.forEach(function (button) {
          if (button.dataset.knUploadCtaReady) return;
          var originalLabel = button.textContent.trim();
          var isPlural = /\b(images|files|photos)\b/i.test(originalLabel);
          var label = isPlural ? card.dataset.uploadCtaMany : card.dataset.uploadCtaSingle;
          var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          icon.setAttribute('viewBox', '0 0 24 24');
          icon.setAttribute('fill', 'none');
          icon.setAttribute('stroke', 'currentColor');
          icon.setAttribute('stroke-width', '1.8');
          icon.setAttribute('stroke-linecap', 'round');
          icon.setAttribute('stroke-linejoin', 'round');
          icon.setAttribute('aria-hidden', 'true');
          icon.innerHTML = '<path d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/>';
          button.textContent = label;
          button.prepend(icon);
          button.dataset.knUploadCtaReady = 'true';
        });
        var isReady = uploadButtons.length > 0 || card.classList.contains('kn-uploadly-card--ready') || !!card.querySelector('.uploadcare--widget, .container_uploader');
        card.classList.toggle('kn-uploadly-card--ready', isReady);
        if (isReady) status.hidden = true;
      }

      function openUploader() {
        if (uploaderBusy()) return;
        var uploadButton = card.querySelector('.uploadcare--widget__button_type_open');
        if (uploadButton) {
          status.hidden = true;
          uploadButton.click();
        } else {
          showStatus(/^(localhost|127\.0\.0\.1)$/.test(location.hostname)
            ? card.dataset.uploadLocal
            : card.dataset.uploadLoading);
        }
      }

      target.addEventListener('click', openUploader);
      previewButton.addEventListener('click', openUploader);
      card.addEventListener('dragenter', function (event) {
        if (!hasFiles(event)) return;
        event.preventDefault();
        dragDepth += 1;
        card.classList.add('kn-uploadly-card--dragging');
      });
      card.addEventListener('dragover', function (event) {
        if (!hasFiles(event)) return;
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
        card.classList.add('kn-uploadly-card--dragging');
      });
      card.addEventListener('dragleave', function (event) {
        if (!hasFiles(event)) return;
        dragDepth = Math.max(0, dragDepth - 1);
        if (!dragDepth) clearDrag();
      });
      card.addEventListener('drop', function (event) {
        if (!hasFiles(event)) return;
        clearDrag();
        if (uploaderBusy()) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        var widget = card.querySelector('.uploadcare--widget');
        if (widget && widget.contains(event.target)) return;
        event.preventDefault();
        event.stopPropagation();
        if (!widget) {
          showStatus(/^(localhost|127\.0\.0\.1)$/.test(location.hostname)
            ? card.dataset.uploadLocal
            : card.dataset.uploadLoading);
          return;
        }
        try {
          widget.dispatchEvent(new DragEvent('drop', {
            bubbles: true,
            cancelable: true,
            dataTransfer: event.dataTransfer
          }));
          status.hidden = true;
        } catch (error) {
          showStatus(card.dataset.uploadDropError);
        }
      });
      new MutationObserver(syncUploader).observe(card, { childList: true, subtree: true });
      syncUploader();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupUploadCards, { once: true });
  } else {
    setupUploadCards();
  }
  document.addEventListener('shopify:section:load', setupUploadCards);
})();
